import { supabase } from "@/lib/supabase/client";

export interface AuditRow {
  id: number;
  tenant_id: string;
  actor_id: string | null;
  actor_type: "user" | "system" | "ai";
  action: string;
  entity_type: string;
  entity_id: string | null;
  created_at: string;
}

const COLS = "id, tenant_id, actor_id, actor_type, action, entity_type, entity_id, created_at";

export async function listAuditEvents(
  tenantId: string,
  opts: { limit?: number; entityType?: string } = {},
): Promise<AuditRow[]> {
  let q = supabase
    .from("audit_log")
    .select(COLS)
    .eq("tenant_id", tenantId)
    .order("created_at", { ascending: false })
    .limit(opts.limit ?? 200);
  if (opts.entityType) q = q.eq("entity_type", opts.entityType);
  const { data, error } = await q;
  if (error) throw new Error(`listAuditEvents: ${error.message}`);
  return data ?? [];
}

/** Render rows as CSV and trigger a browser download. */
export function downloadCsv(filename: string, rows: Record<string, unknown>[]): void {
  const first = rows[0];
  if (!first) return;
  const headers = Object.keys(first);
  const escape = (v: unknown): string => {
    const s =
      v === null || v === undefined
        ? ""
        : typeof v === "string"
          ? v
          : typeof v === "number" || typeof v === "boolean"
            ? String(v)
            : JSON.stringify(v);
    return /[",\n]/.test(s) ? `"${s.replaceAll('"', '""')}"` : s;
  };
  const csv = [
    headers.join(","),
    ...rows.map((r) => headers.map((h) => escape(r[h])).join(",")),
  ].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
